import {
  GET_ADMIN_INTERNAL_USERS,
  GET_ADMIN_INTERNAL_USERS_SUCCESS,
  GET_ADMIN_INTERNAL_USERS_ERROR,
  GET_ALL_ADMIN_EMPLOYEES,
  GET_ALL_ADMIN_EMPLOYEES_SUCCESS,
  GET_ALL_ADMIN_EMPLOYEES_ERROR,
  CREATE_ADMIN_INTERNAL_USER,
  CREATE_ADMIN_INTERNAL_USER_SUCCESS,
  CREATE_ADMIN_INTERNAL_USER_ERROR,
  MODIFY_ADMIN_INTERNAL_USER,
  MODIFY_ADMIN_INTERNAL_USER_SUCCESS,
  MODIFY_ADMIN_INTERNAL_USER_ERROR,
  MODIFY_BULK_ADMIN_INTERNAL_USER,
  MODIFY_BULK_ADMIN_INTERNAL_USER_SUCCESS,
  MODIFY_BULK_ADMIN_INTERNAL_USER_ERROR,
  DELETE_BULK_ADMIN_INTERNAL_USER,
  DELETE_BULK_ADMIN_INTERNAL_USER_SUCCESS,
  DELETE_BULK_ADMIN_INTERNAL_USER_ERROR,
  DELETE_ADMIN_INTERNAL_USER,
  DELETE_ADMIN_INTERNAL_USER_SUCCESS,
  DELETE_ADMIN_INTERNAL_USER_ERROR,
  CREATE_BULK_ADMIN_INTERNAL_USER,
  CREATE_BULK_ADMIN_INTERNAL_USER_SUCCESS,
  CREATE_BULK_ADMIN_INTERNAL_USER_ERROR,
  RESET_INVITE_SENT_TO,
  RESEND_ADMIN_INTERNAL_USER_INVITE,
  RESEND_ADMIN_INTERNAL_USER_INVITE_SUCCESS,
  RESEND_ADMIN_INTERNAL_USER_INVITE_ERROR,
} from "./actionTypes";

export const getAdminInternalUsers = (query_params, paginated) => {
  return {
    type: GET_ADMIN_INTERNAL_USERS,
    payload: query_params, 
    paginated: paginated
  }
}

export const getAdminInternalUsersSuccess = (admin_internal_users, paginated) => {
  return {
    type: GET_ADMIN_INTERNAL_USERS_SUCCESS,
    payload: admin_internal_users,
    paginated: paginated
  }
}

export const getAdminInternalUsersError = error => {
  return {
    type: GET_ADMIN_INTERNAL_USERS_ERROR,
    payload: error,
  }
}

export const getAllAdminEmployees = () => {
  return {
    type: GET_ALL_ADMIN_EMPLOYEES,
  }
}

export const getAllAdminEmployeesSuccess = admin_employees => {
  return {
    type: GET_ALL_ADMIN_EMPLOYEES_SUCCESS,
    payload: admin_employees,
  }
}

export const getAllAdminEmployeesError = error => {
  return {
    type: GET_ALL_ADMIN_EMPLOYEES_ERROR,
    payload: error,
  }
}

export const createAdminInternalUser = admin_internal_users => {
  return {
    type: CREATE_ADMIN_INTERNAL_USER,
    payload: admin_internal_users,
  }
}

export const createAdminInternalUserSuccess = admin_internal_users => {
  return {
    type: CREATE_ADMIN_INTERNAL_USER_SUCCESS,
    payload: admin_internal_users,
  }
}

export const createAdminInternalUserError = error => {
  return {
    type: CREATE_ADMIN_INTERNAL_USER_ERROR,
    payload: error,
  }
}

export const createBulkAdminInternalUser = admin_internal_users => {
  return {
    type: CREATE_BULK_ADMIN_INTERNAL_USER,
    payload: admin_internal_users,
  }
}

export const createBulkAdminInternalUserSuccess = admin_internal_users => {
  return {
    type: CREATE_BULK_ADMIN_INTERNAL_USER_SUCCESS,
    payload: admin_internal_users,
  }
}

export const createBulkAdminInternalUserError = error => {
  return {
    type: CREATE_BULK_ADMIN_INTERNAL_USER_ERROR,
    payload: error,
  }
}

export const updateAdminInternalUser = admin_internal_users => {
  return {
    type: MODIFY_ADMIN_INTERNAL_USER,
    payload: admin_internal_users,
  }
}

export const updateAdminInternalUserSuccess = admin_internal_users => {
  return {
    type: MODIFY_ADMIN_INTERNAL_USER_SUCCESS,
    payload: admin_internal_users,
  }
}

export const updateAdminInternalUserError = error => {
  return {
    type: MODIFY_ADMIN_INTERNAL_USER_ERROR,
    payload: error,
  }
}

export const updateBulkAdminInternalUser = admin_internal_users => {
  return {
    type: MODIFY_BULK_ADMIN_INTERNAL_USER,
    payload: admin_internal_users,
  }
}

export const updateBulkAdminInternalUserSuccess = admin_internal_users => {
  return {
    type: MODIFY_BULK_ADMIN_INTERNAL_USER_SUCCESS,
    payload: admin_internal_users,
  }
}

export const updateBulkAdminInternalUserError = error => {
  return {
    type: MODIFY_BULK_ADMIN_INTERNAL_USER_ERROR,
    payload: error,
  }
}

export const deleteAdminInternalUser = admin_internal_users => {
  return {
    type: DELETE_ADMIN_INTERNAL_USER,
    payload: admin_internal_users,
  }
}

export const deleteAdminInternalUserSuccess = admin_internal_users => {
  return {
    type: DELETE_ADMIN_INTERNAL_USER_SUCCESS,
    payload: admin_internal_users,
  }
}

export const deleteAdminInternalUserError = error => {
  return {
    type: DELETE_ADMIN_INTERNAL_USER_ERROR,
    payload: error,
  }
}

export const deleteBulkAdminInternalUser = admin_internal_users => {
  return {
    type: DELETE_BULK_ADMIN_INTERNAL_USER,
    payload: admin_internal_users,
  }
}

export const deleteBulkAdminInternalUserSuccess = admin_internal_users => {
  return {
    type: DELETE_BULK_ADMIN_INTERNAL_USER_SUCCESS,
    payload: admin_internal_users,
  }
}

export const deleteBulkAdminInternalUserError = error => {
  return {
    type: DELETE_BULK_ADMIN_INTERNAL_USER_ERROR,
    payload: error,
  }
}

export const resendAdminInternalUserInvite = (admin_user) => {
  return {
    type: RESEND_ADMIN_INTERNAL_USER_INVITE,
    payload: admin_user
  }
}

export const resendAdminInternalUserInviteSuccess = (payload) => {
  return {
    type: RESEND_ADMIN_INTERNAL_USER_INVITE_SUCCESS,
    payload: payload
  }
}

export const resendAdminInternalUserInviteError = (error) => {
  return {
    type: RESEND_ADMIN_INTERNAL_USER_INVITE_ERROR,
    payload: error
  }
}

export const resetInviteSentTo = () => {
  return {
    type: RESET_INVITE_SENT_TO,
    error: null
  }
}
